import React, { Component } from 'react';
import { Input as AntdInput, Icon } from 'antd';
import { text, ListRefer, Select, InputNumber, Input, Table } from '../basic';
import { getRoundValue } from '../../helpers/util';
import SvgIcon from 'SvgIcon';
import _ from 'lodash';
export default class FlatRowContainer extends Component {
  constructor(props) {
    super(props);
    const { meta, viewModel, cStyle } = props;
    const { childrenField, cCode } = meta;
    const controlModel = viewModel.get(childrenField || cCode);
    let sunMeta = null;
    let sunActions = null;
    let sunModel = null;
    if (this.props.meta.containers) {
      _.forEach(this.props.meta.containers, (item, index) => {
        item.containers && item.containers.map(container => {
          if (container.cControlType && container.cControlType.toLocaleLowerCase() == 'table') {
            sunMeta = container;
            sunModel = controlModel.getEditRowModel().get(sunMeta.childrenField);
          }
          sunActions = container.containers ? container.containers[0] : {}
        })
      })
    }
    let config = null;
    if (cStyle) {
      try { config = JSON.parse(cStyle); } catch (e) { config = {}; }
    }
    let metacStyle = props.meta.cStyle || "{}";
    try { metacStyle = JSON.parse(metacStyle); } catch (e) { metacStyle = {}; }
    let sunConfig = this.initSunModel(sunModel);
    this.state = Object.assign({
      controlModel,
      sunMeta,
      sunActions,
      actions: meta.containers ? meta.containers[0].controls : [],
      readOnly: false,
      propsOpen: false,
      metaclassname: metacStyle.classname,
      cellState: [],
      actionState: [],
      sunModel,
      sunConfig,
      showColumnName:metacStyle.showColumnName||false,
      focusedIndex: -1,
    }, config);
    this.sunGridModels = {};
  }
  /*初始化孙表*/
  initSunModel = (sunModel) => {
    if (!sunModel) return null;
    let cControlType = sunModel.get('cControlType');
    let columns = sunModel.get('columns');
    let showCheckBox = sunModel.get('showCheckBox');
    let bIsNull = sunModel.get('bIsNull');
    let showRowNo = sunModel.get('showRowNo');
    let showAggregates = sunModel.get('showAggregates');
    let pagination = sunModel.get('pagination');
    let cShowCaption = sunModel.get('cShowCaption');
    return { cControlType, columns, showCheckBox, bIsNull, showRowNo, showAggregates, pagination, cShowCaption, independent: true, readOnly: false };
  }
  componentDidMount() {
    this.state.controlModel && this.state.controlModel.addListener(this);
    let datasource = this.state.controlModel.getAllData();
    this.setState({ datasource })
    this.state.controlModel.setFocusedRowIndex(0);
  }
  componentWillMount() { }
  componentWillUnmount() {
    this.state.controlModel.removeListener(this);
  }
  setListenerState(params) {
    this.setState(params);
  }
  setCellState(data) {
    let { cellState } = this.state;
    cellState[data.rowIndex] = {
      [data.cellName]: {
        [data.propertyName]: data.value
      }
    }
    this.setState({ cellState });
  }
  setDataSource(datasource) {
    this.setState({ datasource });
  }
  setCellValue(data) {
    let { rowIndex, cellName, value } = data;
    let { datasource } = this.state;
    value = typeof value === 'object' && value !== null ? value.value : value
    datasource[rowIndex][cellName] = value;
    this.setDataSource(datasource);
  }
  handleChange(rowIndex, cellName, value) {
    let _value = (value === 0 || !!value) ? value : null;
    this.state.controlModel.setCellValue(rowIndex, cellName, _value, true);
  }
  handelDelListrefer = (e, rowIndex, cellName) => {
    e.stopPropagation();
    this.state.controlModel.setCellValue(rowIndex, cellName, '', true);
  }
  //更新行
  updateRow = (data) => {
    let { datasource } = this.state;
    if (data.index.length) {
      data.index.forEach((rowIndex, index) => {
        datasource[rowIndex] = data.row[index];
      });
    } else {
      datasource[data.index] = data.row;
    }
    this.setState({ datasource })
  }
  getPrecision(iNumPoint, controlType) {
    switch (controlType) {
      case 'money':
        iNumPoint = cb.rest.AppContext.option ? cb.rest.AppContext.option.amountofdecimal : 0;
        break;
      case 'price':
        iNumPoint = cb.rest.AppContext.option ? cb.rest.AppContext.option.monovalentdecimal : 0;
        break;
    }
    return iNumPoint || 0;
  }
  insertRow(data) {
    let { index, row } = data;
    const { datasource } = this.state;
    datasource.splice(index, 0, row);
    this.setState({ datasource, autoLoad: false })
  }
  //单元格数据改变事件
  setCellValue = (data) => {
    let { datasource } = this.state;
    datasource[data.rowIndex][data.cellName] = data.value;
    this.setState({ datasource });
  }
  deleteRows(indexes) {
    let { datasource } = this.state;
    indexes.map(index => {
      delete datasource[index];
    });
    datasource = datasource.filter(v => v);
    this.setState({ datasource, autoLoad: false })
  }
  batchInsertRow(data) {
    const { datasource } = this.state;
    data.forEach(item => {
      const { rowIndex, rowData } = item;
      datasource.splice(rowIndex, 0, rowData);
    });
    this.setState({ datasource })
  }
  setColumns = (columndata) => {
    let { controlModel } = this.state;
    Object.keys(columndata).forEach(val => {
      Object.keys(columndata[val]).forEach(v => {
        controlModel.setColumnState(val, v, columndata[val][v]);
      })
    })
    this.setState({})
  }
  setReadOnly(value) {
    this.setState({ readOnly: value });
  }
  ActionClick = (e, action, index) => {
    if (this.actionClickTime) {
      let nowTime = new Date().valueOf();
      if (nowTime - this.actionClickTime < 1000) return;
      this.actionClickTime = nowTime;
    } else {
      this.actionClickTime = new Date().valueOf();
    }
    this.state.controlModel.setFocusedRowIndex(index);
    this.setState({ focusedIndex: index });
    let viewModel = this.state.controlModel.getParent();
    while (viewModel.getParent())
      viewModel = viewModel.getParent();
    let params = { index: index, cItemName: action.cItemName }
    viewModel.get(action.cItemName).fireEvent('click', params);
  }
  setActionState = (actionstates) => {
    let { actionState } = this.state;
    if (actionstates.length) {
      actionstates.forEach(actionstate => {
        let { rowIndex, cellName, name, value } = actionstate;
        if (typeof actionState[rowIndex] !== 'object') actionState[rowIndex] = {}
        if (typeof actionState[rowIndex][cellName] !== 'object') actionState[rowIndex][cellName] = {}
        actionState[rowIndex][cellName][name] = value
      })
      this.setState({ actionState })
    }
  }
  getAction = (actionList, i) => {
    let { actionState } = this.state;
    return actionList.map((action) => {
      const extraProps = {};
      extraProps.onClick = (e) => this.ActionClick(e, action, i);
      if (!actionState[i] || !actionState[i][action.cItemName] || actionState[i][action.cItemName].visible) {
        return (
          <span key={'action' + i+action.cItemName}>
            <a className="table-list-btn" {...extraProps}>
              {action.icon ? <Icon type={action.icon} /> : null}
              {action.cShowCaption ? action.cShowCaption : null}
            </a>
          </span>
        );
      }
    });
  }
  renderRow = (row, index) => {
    const { columns, propsOpen, cellState, controlModel, disabled, readonly, sunMeta, sunActions, sunConfig,showColumnName } = this.state;
    let items = [];
    let columnindex = 0;
    _.forEach(columns, (column, key) => {
      let item = null;
      let controlType = column.cControlType;
      let model = null;
      if (cellState[index] && cellState[index][key]) {
        column = { ...column, ...cellState[index][key] }
      }
      column.readOnly = !column.bCanModify
      let modelconfig = cb.utils.extend(true, { value: row[key] }, column);
      let cStyleconfig = {};
      if (column.cStyle) {
        try { cStyleconfig = JSON.parse(column.cStyle); } catch (e) { cStyleconfig = {}; }
      }
      let after = cStyleconfig.after || controlModel.getColumnState(key, 'after');
      if(showColumnName) delete modelconfig.cShowCaption
      switch (controlType && controlType.trim().toLocaleLowerCase()) {
        case 'inputnumber':
        case 'money':
        case 'price':
          model = new cb.models.SimpleModel(modelconfig);
          let NumPoint = this.getPrecision(column.iNumPoint, controlType.trim().toLocaleLowerCase())
          item = <div className={`frc-inputnumber ${'frc-inputnumber-' + key}`}>
            {/* {
              column.cShowCaption ?
                <label className='frc-inputnumber-title'>
                  {!column.bIsNull && columnindex == 0 ? <Icon type='star' /> : null}
                  {column.cShowCaption}
                </label>
                : null
            } */}
            <InputNumber model={model} cShowCaption={modelconfig.cShowCaption} iNumPoint={NumPoint} cFormatData={modelconfig.cFormatData} className='frc-inputnumber-content' />
          </div>
          break;
        case 'select':
          model = new cb.models.ListModel(modelconfig);
          item = <div className='frc-select'>
            {/* {
              column.cShowCaption ?
                <label className='frc-select-title'>
                  {!column.bIsNull && columnindex == 0 ? <Icon type='star' /> : null}
                  {column.cShowCaption}
                </label>
                : null
            } */}
            <Select model={model} cShowCaption={modelconfig.cShowCaption} className='frc-select-content' />
          </div>
          break;
        case 'listrefer':
          model = new cb.models.ReferModel(modelconfig);
          item = <ListRefer model={model} className='frc-listrefer' />
          break;
        case 'input':
          model = new cb.models.SimpleModel(modelconfig);
          item = <Input cShowCaption={modelconfig.cShowCaption} model={model} className='frc-input' />
          break;
        default:
          item = <AntdInput value={row[key]} className='member-list-disabled' disabled={disabled} onChange={(e) => this.handleChange(index, key, e.target.value)} />
          if (!disabled && readonly)
            item = <span className='m-title'>{row[key]}</span>
      }
      model !== null && model.on('afterValueChange', (args) => {
        !!args && controlModel.setCellValue(index, key,(cb.utils.isEmpty(args.value)? null :args.value), true, true);
        if (modelconfig.cRefRetId && !!args) {
          let cRefRetId = {}
          try {
            cRefRetId = JSON.parse(modelconfig.cRefRetId);
          } catch (e) { }
          let cRefRetIdarr = Object.keys(cRefRetId);
          cRefRetIdarr.length && cRefRetIdarr.forEach(v => {
            controlModel.setCellValue(index, v, (cb.utils.isEmpty(args.value)? null : (args.value[cRefRetId[v]] || '')), true, true);
          })
        }
      })
      model !== null && model.on('blur', (args) => {
        !!args && controlModel.setCellValue(index, key, (cb.utils.isEmpty(args.value)? null :args.value), true, true);
      });
      model !== null && controlType === 'ListRefer' && model.on('beforeBrowse', () => {
        return controlModel.execute('beforeBrowse', { rowIndex: index, cellName: key, context: model });
      })
      items.push(item)
      columnindex++
    })
    if (sunMeta) {
      let sunModel = null;
      let focusedIndex = controlModel.getFocusedRowIndex()
      if (index == focusedIndex) {
        sunModel = controlModel.getEditRowModel().get(sunMeta.childrenField);
      } else {
        let rowData = controlModel.getRowsByIndexes(index)[0];
        if (!this.sunGridModels['_' + index]) {
          sunConfig.datasource = rowData[sunMeta.childrenField];
          sunConfig.rows = rowData[sunMeta.childrenField];
          sunModel = new cb.models.GridModel(sunConfig)
          this.sunGridModels['_' + index] = sunModel;
        } else {
          sunModel = this.sunGridModels['_' + index];
          sunModel.setDataSource(rowData[sunMeta.childrenField]);
        }
      }
      items.push(
        <div onMouseEnter={() => this.onMouseEnter(index)}>
          <Table height={'1000'} width={this.props.width} action={sunActions} model={sunModel} />
        </div>
      )
    }
    return items
  }
  onMouseEnter = (index) => {
    if (index != this.state.focusedIndex) {
      // this.sunGridModels['_' + this.state.focusedIndex].dop
      this.state.controlModel.setFocusedRowIndex(index);
      this.setState({ focusedIndex: index });
    }
  }
  componentWillUpdate(nextProps, nextState) {
    return !_.eq(this.state, nextState)
  }
  renderReadOnlyRow = (row) => {
    const { columns, controlModel,showColumnName } = this.state;
    let items = []
    _.forEach(columns, (column, key) => {
      let item = null;
      let controlType = column.cControlType;
      let modelconfig = cb.utils.extend(true, { value: row[key] }, column);
      let cStyleconfig = {};
      if (column.cStyle) {
        try { cStyleconfig = JSON.parse(column.cStyle); } catch (e) { cStyleconfig = {}; }
      }
      let after = cStyleconfig.after || controlModel.getColumnState(key, 'after');
      if(showColumnName) delete modelconfig.cShowCaption
      switch (controlType && controlType.trim().toLocaleLowerCase()) {
        case 'inputnumber':
        case 'money':
        case 'price':
          let NumPoint = this.getPrecision(modelconfig.iNumPoint, controlType.trim().toLocaleLowerCase())
          item = <div className={`frc-inputnumber-readonly ${'frc-inputnumber-' + key}`}>
            {modelconfig.cShowCaption ? <span className='frc-inputnumber-title'>{modelconfig.cShowCaption}</span> : null}
            <div className='frc-inputnumber-content'>
              <div className='control-flex'>
                <div className='ant-input-number'>{getRoundValue(Number(row[key]), NumPoint)}</div>
                {after ? <span>{after}</span> : null}
              </div>
            </div>
          </div>
          break;
        case 'select':
          let _obj = JSON.parse(modelconfig.cEnumString) || {}
          item = <div className='frc-select-readonly'>
            <div className='frc-select-title'>
              {modelconfig.cShowCaption ? <span className=''>{modelconfig.cShowCaption}</span> : null}
            </div>
            <div className="frc-select-content">
              {typeof row[key] == 'object' ? row[key].text : _obj[row[key]]}
            </div>
          </div>
          break;
        case 'listrefer':
          item = <div className='frc-listrefer-readonly'>{typeof row[key] == 'object' ? row[key].name : row[key]}</div>
          break;
        case 'input':
          item = <div className='frc-input-readonly'>{row[key]}</div>
          break;
        default:
          item = <span className='m-title'>{row[key]}</span>
      }
      items.push(item)
    })
    return items
  }
  renderRows(datasource) {
    const { readOnly, columns } = this.state;
    const { iCols } = this.props.meta;
    const controlWidth = 100 / (iCols || 2);
    const className = `width-percent-${controlWidth.toFixed(0)}`;
    let { actions } = this.state;
    return datasource.map((row, index) => {
      return (
        <div className={className} key={'row' + index}>
          {readOnly ?
            this.renderReadOnlyRow(row)
            :
            this.renderRow(row, index)
          }
          {
            !!(!readOnly && actions && actions.length) && <div className='flatrowcontainer-action'>
              {this.getAction(actions, index)}
            </div>
          }
        </div>
      );
    });
  }
  renderColums(columns){
    let items=[];
    columns &&  _.forEach(columns, (column, key) => {
      if(column.bHidden || !column.bShowIt) return
      items.push(<span className={column.cItemName}>{column.cShowCaption ||column.cCaption}</span>)
    })
    return <div className='member-list-title'>{items}</div>
  }
  render() {
    let { datasource, classname, metaclassname,showColumnName,columns} = this.state;
    if (!datasource || !datasource.length) datasource = [];
    return (
      <div className={`member-list ${classname || ''} ${metaclassname}`}>
        {showColumnName && this.renderColums(columns)}
        {this.renderRows(datasource)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/meta/FlatRowContainer.jsx